import { Avatar, ListItemText, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useDispatch, useSelector } from "react-redux";
import React, { useState } from "react";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { Grid } from "@mui/material";
import { IReduxState } from "../../store";
import MenuApp from "./MenuApp";
import { SITEWEB_SERVER_BASE_URL } from "../../util/apiClient";
import _ from "lodash";
import UpdateIcon from '@mui/icons-material/Update';
import { formatDate } from "../../util/functions";


const Liste = () => {

  const dispatch = useDispatch();
  const { filteredMajSpiders } = useSelector((state: IReduxState) => state.siteWeb);
  console.log("🚀 ~ file: Liste.tsx:24 ~ Liste ~ filteredMajSpiders:", filteredMajSpiders)

  //hooks

  return (
    <>
      <div
        style={{
          padding: 10,
          height: "55vh",
          overflow: "auto",
        }}
      >

        <Box sx={{ flexGrow: 1, width: "100%" }}>
          <List dense={true}>
            {filteredMajSpiders.map((item, i: number) => {
              return (
                <div key={i}>
                  <ListItem
                    secondaryAction={
                      <MenuApp
                        item={item}
                      />
                    }
                  >
                    <ListItem>
                      <ListItemIcon>
                        <UpdateIcon />
                      </ListItemIcon>

                      <ListItemButton>
                        <ListItemText
                          primary={`Version: ${item.versionNumber}`}
                          secondary={`Date version: ${formatDate(item.versionDate)}`}
                        />
                      </ListItemButton>
                    </ListItem>
                  </ListItem>
                  <Divider />
                </div>
              );
            })}
          </List>
        </Box>
      </div>
    </>
  );
};
export default Liste;
